import { useState } from 'react';
import MasterDataPanel from './components/MasterDataPanel';

const tabs = [
  {
    id: 'company-types',
    label: 'Company Types',
    icon: 'ri-building-4-line',
    endpoint: '/masters/company-types',
    subtitle: 'Categories of companies registered on the platform',
  },
  {
    id: 'customer-types',
    label: 'Customer Types',
    icon: 'ri-user-line',
    endpoint: '/masters/customer-types',
    subtitle: 'Customer classification categories',
  },
  {
    id: 'id-types',
    label: 'ID Types',
    icon: 'ri-id-card-line',
    endpoint: '/masters/id-types',
    subtitle: 'Government and official identity document types',
    showFormatHint: true,
  },
  {
    id: 'document-categories',
    label: 'Document Categories',
    icon: 'ri-folder-5-line',
    endpoint: '/masters/document-categories',
    subtitle: 'Categories used to classify uploaded documents',
  },
] as const;

type TabId = (typeof tabs)[number]['id'];

export default function Masters() {
  const [activeTab, setActiveTab] = useState<TabId>('company-types');
  const activeTabData = tabs.find((t) => t.id === activeTab)!;

  return (
    <div className="p-4 md:p-8 min-h-screen">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-stone-900">Masters</h1>
        <p className="text-stone-500 text-sm mt-1">
          Manage platform-wide master data categories for companies, customers, documents, and identity types.
        </p>
      </div>

      {/* Tabs */}
      <div className="mb-6">
        <div className="flex flex-wrap gap-2 bg-white rounded-xl border border-stone-100 p-1.5">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                activeTab === tab.id
                  ? 'bg-brand-50 text-brand-700'
                  : 'text-stone-500 hover:text-stone-700 hover:bg-stone-50'
              }`}
            >
              <i className={`${tab.icon} text-base`} />
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Panel */}
      <MasterDataPanel
        key={activeTab}
        title={activeTabData.label}
        subtitle={activeTabData.subtitle}
        icon={activeTabData.icon}
        endpoint={activeTabData.endpoint}
        showFormatHint={activeTabData.showFormatHint}
      />
    </div>
  );
}